import RSVPDeclined from './RSVPDeclined';

export default RSVPDeclined;
